import * as yup from 'yup';
import { IScaleRating, OptionalScaleRatingSchema } from '../../../common';

export const CarePlan2Schema = yup.object({
  bladderControl: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  continenceProfile: yup.string().notRequired().nullable(),
  stoolControl: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  obstipation: yup.boolean().notRequired().default(false),
  diarrhoe: yup.boolean().notRequired().default(false),
  copingUrinaryIncontinence: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  copingStoolIncontinence: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  usageToilet: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  intertrigoRiskChkb: yup.boolean().notRequired().default(false),
  catheterChkb: yup.boolean().notRequired().default(false),
  stoma: yup.boolean().notRequired().default(false),
  infectionRisk: yup.boolean().notRequired().default(false),
  intertrigoRisk: yup.string().notRequired().nullable(),
  catheter: yup.string().notRequired().nullable(),
  careHead: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  dentalStatusNotPresent: yup.boolean().notRequired().default(false),
  upperJaw: yup.boolean().notRequired().default(false),
  lowerJaw: yup.boolean().notRequired().default(false),
  dentalProsthesisTopChkb: yup.boolean().notRequired().default(false),
  dentalProsthesisBottomChkb: yup.boolean().notRequired().default(false),
  dentalProsthesisTop: yup.string().notRequired().nullable(),
  dentalProsthesisBottom: yup.string().notRequired().nullable(),
  prosthesisCare: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  glassesChkb: yup.boolean().notRequired().default(false),
  glasses: yup.array(yup.string().notRequired()).nullable().default([]),
  handleGlasses: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  hearingAidChkb: yup.boolean().notRequired().default(false),
  hearingAid: yup.array(yup.string().required()).nullable().default([]),
  handleHearingAid: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  washingUpperBodyFront: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  washingUpperBodyBack: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  washingLowerBody: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  washingGenitalArea: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  showeringAndBathing: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  dressingUpperBody: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  dressingLowerBody: OptionalScaleRatingSchema.notRequired().nullable().default({}),
  habitsBaseCare: yup.string().notRequired().nullable(),
  habitsClothing: yup.string().notRequired().nullable(),
  additionalInfo: yup.string().notRequired().nullable(),
  goals: yup.string().notRequired().nullable(),
  measureDescription: yup.string().notRequired().nullable(),
  incontinenceProductsDayOpenChkb: yup.boolean().notRequired().default(false),
  incontinenceProductsDayOpen: yup.string().notRequired().nullable(),
  incontinenceProductsDayClosedChkb: yup.boolean().notRequired().default(false),
  incontinenceProductsDayClosed: yup.string().notRequired().nullable(),
  incontinenceProductsNightOpenChkb: yup.boolean().notRequired().default(false),
  incontinenceProductsNightOpen: yup.string().notRequired().nullable(),
  incontinenceProductsNightClosedChkb: yup.boolean().notRequired().default(false),
  incontinenceProductsNightClosed: yup.string().notRequired().nullable(),
  catheterMeasure: yup.object({
    changedBy: yup.string().notRequired().nullable(),
    charr: yup.string().notRequired().nullable(),
    blocking: yup.number().notRequired().nullable(),
    intervalWeeks: yup.number().notRequired().nullable(),
    infectionProphylaxis: yup.number().notRequired().nullable(),
    protocol: yup.boolean().notRequired().default(false),
    detail: yup.string().notRequired().nullable(),
    description: yup.string().notRequired().nullable(),
    changeBagDay: yup.number().notRequired().nullable(),
    changeBagNight: yup.number().notRequired().nullable(),
    emptyBagDay: yup.number().notRequired().nullable(),
    emptyBagNight: yup.number().notRequired().nullable(),
  }),
  stomaMeasure: yup.object({
    emptyBag: yup.number().notRequired().nullable(),
    changeBag: yup.number().notRequired().nullable(),
    changePlate: yup.number().notRequired().nullable(),
  }),
  intertrigoProphylaxis: yup.object({
    time: yup.number().notRequired().nullable(),
    description: yup.string().notRequired().nullable(),
  }),
  skinInspection: yup.string().notRequired().nullable(),
  washingMorningChkb: yup.boolean().notRequired().default(false),
  washingMorningRdb: yup.string().notRequired().nullable(),
  washingMorningCompletely: yup.object({
    washingMorningCompletelyTime: yup.date().notRequired().nullable(),
    washingMorningCompletelyLocation: yup.string().notRequired().nullable(),
    washingMorningCompletelyType: yup.string().notRequired().nullable(),
  }),
  washingMorningPartly: yup.object({
    washingMorningPartlyTime: yup.date().notRequired().nullable(),
    washingMorningPartlyLocation: yup.string().notRequired().nullable(),
    washingMorningPartlyType: yup.string().notRequired().nullable(),
  }),
  washingEvening: yup.boolean().notRequired().default(false),
  washingEveningRdb: yup.string().notRequired().nullable(),
  washingEveningCompletely: yup.object({
    washingEveningCompletelyTime: yup.date().notRequired().nullable(),
    washingEveningCompletelyLocation: yup.string().notRequired().nullable(),
    washingEveningCompletelyType: yup.string().notRequired().nullable(),
  }),
  washingEveningPartly: yup.object({
    washingEveningPartlyTime: yup.date().notRequired().nullable(),
    washingEveningPartlyLocation: yup.string().notRequired().nullable(),
    washingEveningPartlyType: yup.string().notRequired().nullable(),
  }),
  dressing: yup.boolean().notRequired().default(false),
  oralCareChkb: yup.boolean().notRequired().default(false),
  dressingType: yup.string().notRequired().nullable(),
  oralCare: yup.object({
    oralCareAmount: yup.number().notRequired().nullable(),
    oralCareDescription: yup.string().notRequired().nullable(),
  }),
  glassesMeasures: yup.string().notRequired().nullable(),
  compressionStockingsChkb: yup.boolean().notRequired().default(false),
  hearingAidMeasures: yup.string().notRequired().nullable(),
  compressionStockings: yup.object({
    checked: yup.array(yup.string().required()).nullable().default([]),
    drp: yup.number().notRequired().nullable(),
  }),
  compressionStockingsRdb: yup.string().notRequired().nullable(),
  additionalMeasures: yup.string().notRequired().nullable(),
});

export interface ICarePlan2 {
  bladderControl: Partial<IScaleRating>;
  continenceProfile?: string;
  stoolControl: Partial<IScaleRating>;
  obstipation?: boolean;
  diarrhoe?: boolean;
  copingUrinaryIncontinence: Partial<IScaleRating>;
  copingStoolIncontinence: Partial<IScaleRating>;
  usageToilet: Partial<IScaleRating>;
  intertrigoRiskChkb?: boolean;
  catheterChkb?: boolean;
  stoma?: boolean;
  infectionRisk?: boolean;
  intertrigoRisk?: string;
  catheter?: string;
  careHead: Partial<IScaleRating>;
  dentalStatusNotPresent?: boolean;
  upperJaw?: boolean;
  lowerJaw?: boolean;
  dentalProsthesisTopChkb?: boolean;
  dentalProsthesisBottomChkb?: boolean;
  dentalProsthesisTop?: string;
  dentalProsthesisBottom?: string;
  prosthesisCare: Partial<IScaleRating>;
  glassesChkb?: boolean;
  glasses?: string[];
  handleGlasses: Partial<IScaleRating>;
  hearingAidChkb?: boolean;
  hearingAid?: string[];
  handleHearingAid: Partial<IScaleRating>;
  washingUpperBodyFront: Partial<IScaleRating>;
  washingUpperBodyBack: Partial<IScaleRating>;
  washingLowerBody: Partial<IScaleRating>;
  washingGenitalArea: Partial<IScaleRating>;
  showeringAndBathing: Partial<IScaleRating>;
  dressingUpperBody: Partial<IScaleRating>;
  dressingLowerBody: Partial<IScaleRating>;
  habitsBaseCare?: string;
  habitsClothing?: string;
  additionalInfo?: string;
  goals?: string;
  measureDescription?: string;
  incontinenceProductsDayOpenChkb?: boolean;
  incontinenceProductsDayOpen?: string;
  incontinenceProductsDayClosedChkb?: boolean;
  incontinenceProductsDayClosed?: string;
  incontinenceProductsNightOpenChkb?: boolean;
  incontinenceProductsNightOpen?: string;
  incontinenceProductsNightClosedChkb?: boolean;
  incontinenceProductsNightClosed?: string;
  catheterMeasure: ICatheterMeasure;
  stomaMeasure: IStomaMeasure;
  intertrigoProphylaxis: IIntertrigoProphylaxis;
  skinInspection?: string;
  washingMorningChkb?: boolean;
  washingMorningRdb?: string;
  washingMorningCompletely: IWashingMorningCompletely;
  washingMorningPartly: IWashingMorningPartly;
  washingEvening?: boolean;
  washingEveningRdb?: string;
  washingEveningCompletely: IWashingEveningCompletely;
  washingEveningPartly: IWashingEveningPartly;
  dressing?: boolean;
  oralCareChkb?: boolean;
  dressingType?: string;
  oralCare: IOralCare;
  glassesMeasures?: string;
  compressionStockingsChkb?: boolean;
  hearingAidMeasures?: string;
  compressionStockings: ICompression;
  compressionStockingsRdb?: string;
  additionalMeasures?: string;
}

export interface ICatheterMeasure {
  changedBy?: string;
  charr?: string;
  blocking?: number;
  intervalWeeks?: number;
  infectionProphylaxis?: number;
  protocol?: boolean;
  detail?: string;
  description?: string;
  changeBagDay?: number;
  changeBagNight?: number;
  emptyBagDay?: number;
  emptyBagNight?: number;
  bagTypeDay?: string | null;
  bagTypeNight?: string | null;
}

export interface IStomaMeasure {
  emptyBag?: number;
  changeBag?: number;
  changePlate?: number;
}

export interface IIntertrigoProphylaxis {
  time?: number;
  description?: string;
}

export interface IWashingMorningCompletely {
  washingMorningCompletelyTime?: Date;
  washingMorningCompletelyLocation?: string;
  washingMorningCompletelyType?: string;
}

export interface IWashingMorningPartly {
  washingMorningPartlyTime?: Date;
  washingMorningPartlyLocation?: string;
  washingMorningPartlyType?: string;
}

export interface IWashingEveningCompletely {
  washingEveningCompletelyTime?: Date;
  washingEveningCompletelyLocation?: string;
  washingEveningCompletelyType?: string;
}

export interface IWashingEveningPartly {
  washingEveningPartlyTime?: Date;
  washingEveningPartlyLocation?: string;
  washingEveningPartlyType?: string;
}

export interface IOralCare {
  oralCareAmount?: number;
  oralCareDescription?: string;
}

export interface ICompression {
  checked?: string[];
  drp?: number;
}
